import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import Modal from "../shared/modal";
import Busy from "../shared/busy";
import { AlertError } from "../../src/View/UI/StandardAlerts/StandardAlerts";
export default class EmailPreviewModal extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            subject: {
                value: "",
                isLoading: true,
                hasError: false,
                errorMessage: "",
            },
            body: {
                value: "",
                isLoading: true,
                hasError: false,
                errorMessage: "",
            },
        };
        this.refreshSubject = () => {
            this.setState((prevState) => ({
                subject: {
                    value: prevState.subject.value || "",
                    isLoading: true,
                    hasError: false,
                    errorMessage: "",
                },
            }));
            this.props
                .loadSubject()
                .then((value) => this.setState((prevState) => ({
                subject: Object.assign(Object.assign({}, prevState.subject), { value }),
            })))
                .catch((error) => {
                this.setState((prevState) => ({
                    subject: Object.assign(Object.assign({}, prevState.subject), { hasError: true, errorMessage: typeof error === "string"
                            ? error
                            : "Unknown error loading email subject" }),
                }));
            })
                // $FlowFixMe - finally is only supported in later versions of flow.
                .finally(() => this.setState((prevState) => ({
                subject: Object.assign(Object.assign({}, prevState.subject), { isLoading: false }),
            })));
        };
        this.refreshBody = () => {
            this.setState((prevState) => ({
                body: {
                    value: prevState.body.value || "",
                    isLoading: true,
                    hasError: false,
                    errorMessage: "",
                },
            }));
            this.props
                .loadBody()
                .then((value) => this.setState((prevState) => ({ body: Object.assign(Object.assign({}, prevState.body), { value }) })))
                .catch((error) => {
                this.setState((prevState) => ({
                    body: Object.assign(Object.assign({}, prevState.body), { hasError: true, errorMessage: typeof error === "string"
                            ? error
                            : "Unknown error loading email body" }),
                }));
            })
                // $FlowFixMe - finally is only supported in later versions of flow.
                .finally(() => this.setState((prevState) => ({
                body: Object.assign(Object.assign({}, prevState.body), { isLoading: false }),
            })));
        };
        this.renderEmailField = (field) => {
            if (field.isLoading) {
                return (_jsx("div", { children: _jsx(Busy, { isBusy: true }) }));
            }
            if (field.hasError) {
                return (_jsx(AlertError, { message: "Error loading this field", detail: field.errorMessage }));
            }
            return _jsx("div", { dangerouslySetInnerHTML: { __html: field.value || "" } }); // eslint-disable-line react/no-danger
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.refreshSubject();
            this.refreshBody();
        }
    }
    render() {
        return (_jsx(Modal, { isOpen: this.props.isOpen, onCloseModal: this.props.onCloseModal, modalId: this.props.modalId, children: _jsx("div", { className: "modal-dialog", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsx("div", { className: "modal-header", children: "Email Preview" }), _jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "subject", children: "Subject" }), this.renderEmailField(this.state.subject)] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "body", children: "Body" }), this.renderEmailField(this.state.body)] })] }), _jsx("div", { className: "modal-footer", children: _jsx("button", { className: "btn btn-outline-secondary", type: "button", onClick: () => this.props.onCloseModal(), children: "Close" }) })] }) }) }));
    }
}
